module.exports = __webpack_public_path__ + "static/media/cwiczenie_1.7e2ff372.jpg";